import api from "./api"

const PaymentService = {
  // ✅ Get All Payments
  GetAllPayments: () => {
    return api
      .get("/Payment/GetAllPayment")
      .then((response) => response)
      .catch((error) => {
        console.error("Service Error - GetAllPayments:", error)
        throw error
      })
  },

  // ✅ Get Payment by ID
  GetPaymentById: (paymentId) => {
    if (!paymentId) {
      return Promise.reject(new Error("Payment ID is required"))
    }
    return api
      .get(`/Payment/GetPaymentById`, {
        params: {
          payment_id: paymentId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        console.error("Service Error - GetPaymentById:", error)
        throw error
      })
  },

  // ✅ Get Payment Details by ID (with typo)
  GetPaymentDetailsById: (paymentId) => {
    if (!paymentId) {
      return Promise.reject(new Error("Payment ID is required"))
    }
    return api
      .get(`/Payment/GetPaymentDetialsById`, {
        params: {
          payment_id: paymentId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        console.error("Service Error - GetPaymentDetailsById:", error)
        throw error
      })
  },

  // ✅ Single method for both Add and Update Payment
  // If payment_id is provided -> UPDATE, otherwise -> CREATE
  SavePayment: (data) => {
  console.log("📤 PaymentService - SavePayment Data:", data)

  // Check if trying to update a fully paid payment (prevent API call)
  if (data.payment_id && data.status === 'Paid') {
    return Promise.reject(new Error("Cannot update a payment that is already fully paid."));
  }

  // Prepare query parameters
  const params = {}

    // Required fields for CREATE
    if (!data.payment_id) {
      // CREATE mode - require license_id and total_amount
      if (!data?.license_id) {
        return Promise.reject(new Error("License ID is required for creating payment"))
      }
      if (!data?.total_amount) {
        return Promise.reject(new Error("Total Amount is required for creating payment"))
      }
      params.license_id = data.license_id
    } else {
      // UPDATE mode - require payment_id
      params.payment_id = data.payment_id
    }

    // Add optional/common fields
    if (data.payment_plan) params.payment_plan = data.payment_plan
    if (data.total_amount !== undefined) params.total_amount = parseFloat(data.total_amount) || 0
    if (data.paid_amount !== undefined) params.paid_amount = parseFloat(data.paid_amount) || 0
    if (data.payment_method) params.payment_method = data.payment_method
    if (data.remarks !== undefined) params.remarks = data.remarks
    
    // For UPDATE mode, also accept license_id if provided
    if (data.payment_id && data.license_id) {
      params.license_id = data.license_id
    }

    console.log("📤 PaymentService - SavePayment Params:", params)

    // Always use POST to the same endpoint
    return api
      .post("/Payment/AddPayment", null, { params })
      .then((response) => {
        console.log("✅ PaymentService - SavePayment Success:", response.data)
        return response
      })
      .catch((error) => {
        console.error("❌ PaymentService - SavePayment Error:", error)
        throw error
      })
  },
}

export default PaymentService